import { gql } from '@yi/core';

import type { Teacher, Image } from '../types';

export function extractDescriptionProps<
  T extends { props?: Array<{ name: string } | null> | null } & object,
>(data: T) {
  return data.props;
}

export function extractContentId<T extends { id: string }>(data: T) {
  return data.id;
}

export function extractTitle<T extends { title: string }>(data: T) {
  return data.title;
}

export function extractCompletedCount<T extends { completed_count?: number } & object>(
  data: T,
): number {
  return data.completed_count ?? 0;
}

export function extractTeacher<T extends { teacher: Teacher }>(data: T) {
  return data.teacher;
}

export function extractBackgroundImg<T extends { no_text_image?: Image } & object>(data: T) {
  return data?.no_text_image?.processed_url ?? '';
}

export function isAudio<T extends { entry_type?: gql.typesSsr.ArticleType } & object>(data: T) {
  const isAudioContent = 'entry_type' in data && data.entry_type === gql.typesSsr.ArticleType.AUDIO;
  return isAudioContent;
}
